module.exports = __webpack_public_path__ + "img/rain.54991fef.svg";